import autoTable from "jspdf-autotable";
import { PDF_TABLE_STYLE,PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawShopTable(doc, shop, rows, total) {
  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 20
    : 28;
function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

  const columnStyles = {
    0: { cellWidth: 30, halign: "left" },
    1: { cellWidth: 24 },
    2: { cellWidth: 24 },
    3: { cellWidth: 24 },
    4: { cellWidth: 24 },
    5: { cellWidth: 24 },
    6: { cellWidth: 24 },
    7: { cellWidth: 24 },
    8: { cellWidth: 24 },
    9: { cellWidth: 23 },
    10: { cellWidth: 24 },
  };


  const pageHeight = doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 25) {
    doc.addPage();
    startY = 28;
  }

  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_GROUP); // Blue background
  doc.rect(14, startY - 10, 270, 8, "F");
  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_GROUP); // White text
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_BODY);
  doc.text(`Shop Number - ${shop}`, 20, startY - 5);
  autoTable(doc, {
    startY,
...PDF_TABLE_STYLE,
    head: [[
      "Work Order",
      "H Skill Time",
      "H Skill Cost",
      "Skilled Time",
      "Skilled Cost",
      "S Skilled Time",
      "S Skilled Cost",
      "UnSkilled Time",
      "UnSkilled Cost",
      "O/C Labour",
      "O/C Store",
    ]],






    body: rows.map(r => [
      r.WORKORDERNUMBER,
      format(r.HIGHLYSKILLEDTIME),
      format(r.HIGHLYSKILLEDCOST),
      format(r.SKILLEDTIME),
      format(r.SKILLEDCOST),
      format(r.SEMISKILLEDTIME),
      format(r.SEMISKILLEDCOST),
      format(r.UNSKILLEDTIME),
      format(r.UNSKILLEDCOST),
      format(r.ONCOSTLABOUR),
      format(r.ONCOSTSTORE),
      r.LABOURMONTH,
      r.LABOURYEAR,
    ]),

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      halign: "right"
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      halign: "center",
      fontStyle: "bold"
    },

    columnStyles,


  });

  const y = doc.lastAutoTable.finalY;

  autoTable(doc, {
    startY: y,
    body: [[
      `SHOP TOTAL - ${String(shop).trim()}`,
      format(total.highlyskilledtime.toFixed(2)),
      format(total.highlyskilledcost.toFixed(2)),
      format(total.skilledtime.toFixed(2)),
      format(total.skilledcost.toFixed(2)),
      format(total.semiskilledtime.toFixed(2)),
      format(total.semiskilledcost.toFixed(2)),
      format(total.unskilledtime.toFixed(2)),
      format(total.unskilledcost.toFixed(2)),
      format(total.oncostlabour.toFixed(2)),
      format(total.oncoststore.toFixed(2)),
    ]],

    theme: "plain",
    styles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_TOTAL,
      textColor: PDFCOLORSHEME.FONT_COLOR_GRAND_TOTAL,
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      fontStyle: "bold",
      halign: "right"
    },
    columnStyles,


  });

}